import { AlertTriangle, RefreshCw } from "lucide-react";

import { Button } from "./button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "./card";

export function ErrorBoundary() {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full min-w-[300px] max-w-md">
        <CardHeader>
          <div className="flex items-flex-start gap-3">
            <div className="flex w-10 justify-center rounded-full bg-destructive/10">
              <AlertTriangle className="h-6 w-6 text-destructive" />
            </div>
            <div>
              <CardTitle className="">Произошла ошибка</CardTitle>
            </div>
          </div>
        </CardHeader>
        <CardContent className="!pt-0 mb-8">
          <CardDescription>
            Мы уже получили уведомление об этом и работаем над исправлением. Пожалуйста, попробуйте
            перезагрузить страницу.
          </CardDescription>
        </CardContent>
        <CardFooter className="flex gap-2 flex-wrap justify-end !p-0">
          <Button onClick={handleReload} className="flex">
            <RefreshCw className="mr-2 h-4 w-4" />
            Обновить страницу
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
